import { render, staticRenderFns } from "./UserOption.vue?vue&type=template&id=3c989aeb&scoped=true&"
import script from "./UserOption.vue?vue&type=script&lang=ts&"
export * from "./UserOption.vue?vue&type=script&lang=ts&"
import style0 from "./UserOption.vue?vue&type=style&index=0&id=3c989aeb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c989aeb",
  null
  
)

export default component.exports